import { useInfiniteQuery, keepPreviousData } from '@tanstack/react-query';
import { useMemo } from 'react';

import { useGetCustomFingerprint } from '../useGetCustomFingerprint';
import { getElasticOfferingSearch } from 'services/elastic-search';

const useGetElasticOfferingsInfinite = ({
  query,
  size,
  categoryLabel,
  sortBy,
  enabled,
  regulationTypes,
}) => {
  const { fingerprint } = useGetCustomFingerprint();

  const queryKey = useMemo(
    () => [
      'elasticOfferingsInfinite',
      query,
      size,
      fingerprint,
      sortBy,
      categoryLabel,
      regulationTypes,
    ],
    [query, size, fingerprint, sortBy, categoryLabel, regulationTypes],
  );

  const {
    data,
    isFetching,
    error,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    refetch,
    isSuccess,
  } = useInfiniteQuery({
    queryKey,
    queryFn: async ({ pageParam = 0 }) => {
      const data = await getElasticOfferingSearch({
        page: pageParam,
        query,
        size,
        categoryLabel,
        sortBy,
        fingerprint,
        regulationTypes,
      });

      return data;
    },
    getNextPageParam: (lastPage) => {
      if (!lastPage) return undefined;

      const { pageNumber, totalPages } = lastPage;
      return pageNumber < totalPages - 1 ? pageNumber + 1 : undefined;
    },
    placeholderData: keepPreviousData,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    enabled: enabled && !!query,
    staleTime: 10 * 60 * 1000, // 10 minutes
    gcTime: 15 * 60 * 1000, // 15 minutes
  });

  return {
    data,
    isFetching,
    error,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    refetch,
    isSuccess,
  };
};

export default useGetElasticOfferingsInfinite;
